import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Grid } from 'semantic-ui-react';
import LineItemShow from './LineItemShow';
import LineItemsSortable from './LineItemsSortable';
import LineItemsHeader from './LineItemsHeader';
import currencyFormatter from 'currency-formatter';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { SummaryTotals } from '../../../Elements';

export default class LineItemsComponent extends React.Component {
  static propTypes = {
    canHideTotal: PropTypes.bool,
    toggleHideTotal: PropTypes.func,
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    hideTotal: PropTypes.bool,
    lineItems: PropTypes.array.isRequired,
    localLineItems: PropTypes.array.isRequired,
    lineItemChangeHandler: PropTypes.func.isRequired,
    totalPaid: PropTypes.number,
    moveLineItem: PropTypes.func.isRequired,
    updateLineItem: PropTypes.func.isRequired,
    deleteLineItem: PropTypes.func.isRequired,
    resetEditLineItem: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.getTotal = this.getTotal.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.state = {
      draggingIndex: null
    };
  }

  onDragEnd({ source, destination }) {
    // Check that item is dropped on a valid drop destination
    if (source && destination) {
      this.setState({ draggingIndex: null });
      this.props.moveLineItem(source.index, destination.index);
    }
  }

  onDragStart({ source }) {
    this.setState({ draggingIndex: source.index });
  }

  getTotal(services) {
    let total = 0;
    services.map(service => {
      const quantity = service.node.quantity || 1;
      const price = service.node.price_cents || 0;
      total += parseFloat(price * parseInt(quantity, 10) / 100);
      return service;
    });
    return total;
  }

  render() {
    const { hideTotal, toggleHideTotal } = this.props;
    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column computer={16} tablet={16} mobile={16}>
            {this.props.lineItems.length === 0 &&
              <div style={{ textAlign: 'center' }}>
                <h4>This event has no line items</h4>
              </div>}
            {this.props.lineItems.length > 0 && <LineItemsHeader />}
            {!this.props.readOnly &&
              <DragDropContext
                onDragEnd={this.onDragEnd}
                onDragStart={this.onDragStart}
              >
                <Droppable droppableId={'line_items'}>
                  {provided =>
                    <div>
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        <LineItemsSortable
                          draggingIndex={this.state.draggingIndex}
                          lineItems={this.props.lineItems}
                          localLineItems={this.props.localLineItems}
                          lineItemChangeHandler={
                            this.props.lineItemChangeHandler
                          }
                          updateLineItem={this.props.updateLineItem}
                          resetEditLineItem={this.props.resetEditLineItem}
                          deleteLineItem={this.props.deleteLineItem}
                        />
                      </div>
                      {provided.placeholder}
                    </div>}
                </Droppable>
              </DragDropContext>}
            {this.props.readOnly &&
              <div>
                {this.props.lineItems.map((service, idx) =>
                  <LineItemShow
                    service={service.node}
                    key={service.node.id || idx}
                    index={idx}
                    readOnly={this.props.readOnly}
                  />
                )}
              </div>}
            {this.props.lineItems.length > 0 &&
              !(this.props.hideTotal && this.props.readOnly) &&
              <Grid padded relaxed>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Divider />
                  </Grid.Column>
                </Grid.Row>
                {!this.props.hideTotal &&
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <SummaryTotals>
                        <SummaryTotals.Row
                          label='Total'
                          style={
                            this.props.totalPaid ? {} : { fontWeight: 'bold' }
                          }
                          value={currencyFormatter.format(
                            this.getTotal(this.props.localLineItems),
                            {
                              code: this.props.localLineItems[0].node
                                .price_currency
                            }
                          )}
                        />
                        {this.props.totalPaid != null && [
                          <SummaryTotals.Row
                            label='Amount Paid'
                            key='paymentsMade'
                            minus
                            value={currencyFormatter.format(
                              this.props.totalPaid / 100,
                              {
                                code: this.props.localLineItems[0].node
                                  .price_currency
                              }
                            )}
                          />,
                          <SummaryTotals.Break key='break' />,
                          <SummaryTotals.Row
                            style={{ fontWeight: 'bold' }}
                            label='Remaining Balance'
                            key='remainingBalance'
                            value={currencyFormatter.format(
                              this.getTotal(this.props.localLineItems) -
                                this.props.totalPaid / 100,
                              {
                                code: 'USD'
                              }
                            )}
                          />
                        ]}
                      </SummaryTotals>
                    </Grid.Column>
                  </Grid.Row>}
                {this.props.canHideTotal && !this.props.readOnly &&
                  <Grid.Row>
                    <Grid.Column width={16} textAlign='right'>
                      <Button
                        content={`${hideTotal ? 'Show' : 'Hide'} Total`}
                        onClick={() => toggleHideTotal()}
                        basic
                        negative={!hideTotal}
                        positive={hideTotal}
                        icon={`${hideTotal ? 'plus' : 'minus'} circle`}
                      />
                    </Grid.Column>
                  </Grid.Row>}
              </Grid>}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/LineItems/LineItems.js